import styled, { keyframes } from 'styled-components';
import { themeColor } from '../../../../../theme/getters';

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 100px;
  height: 59px;
`;

const bounce = keyframes`
  0%, 80%, 100% { 
    transform: scale(0);
  }
  40% { 
    transform: scale(1.0);
  }
`;

export const Dot = styled.div`
  width: 18px;
  height: 18px;
  background-color: ${themeColor('primary')};
  border-radius: 100%;
  vertical-align: middle;
  display: inline-block;
  animation: ${bounce} 1.4s infinite ease-in-out both;
  margin-right: 10px;

  &:nth-of-type(1) {
    animation-delay: -0.32s;
  }

  &:nth-of-type(2) {
    animation-delay: -0.16s;
  }
`;
